import { object, bool, string } from 'prop-types'
import { useEffect, useState } from 'react'
import { TableCustom } from "../../common"
import { GetMeses } from '../../../utils/helpers'
import { getDateToString } from '../../../utils/convert'
import RetencionModal from '../RetencionModal'

const RetencionesGrid = (props) => {

    const [state, setState] = useState({
        idCuenta: 0,
        list: []
    });

    const [edit, setEdit] = useState({ mode: null, item: null, })

    const mount = () => {
        setState(prevState => {
        return {...prevState,
            idCuenta: props.data.idCuenta,
            list: props.data.list };
        });
    }
    useEffect(mount, [props.data]);

    const avmr = {
        onView: (item) => {
            setEdit({ mode: 'view', item, })
        }
    }

    const meses = GetMeses(false);
    const getMes = (row) => {
        return (row) ? meses.find(f => f.key === row.mesDeclaracion).code : '';
    }

    return (
        <div>
            <TableCustom
                className="TableCustomBase"
                data={state.list}
                avmr={avmr}
                columns={[
                    { Header: 'Fecha presentación', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaPresentacion', width: '25%' },
                    { Header: 'Año', accessor: 'anioDeclaracion', width: '25%' },
                    { Header: 'Mes', accessor: 'mesDeclaracion', Cell: (props) => getMes(props.row.original), width: '25%' },
                    { Header: 'Número', accessor: 'numero', width: '25%' }
                ]}
                disabled={ props.disabled }
                showFilterGlobal={false}
            />

            {edit.mode && (
                <RetencionModal
                    data={{
                        entity: edit.item
                    }}
                    onCancel={() => setEdit({ mode: null, item: null })}
                />
            )}

        </div>
    )
}

RetencionesGrid.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired
}
  
RetencionesGrid.defaultProps = {
    disabled: false,
}

export default RetencionesGrid
